module.exports = __webpack_public_path__ + "static/media/logo.925020a1.png";